import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import dayjs from "dayjs";
import { Box, Divider, Stack, Typography } from "@mui/material";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { getTokenOrderById } from "src/api/tokenTransaction";

import font from "src/styles/font";
import { Grey, White, White01 } from "src/styles/color";
import { convertPrice } from "src/common";

import Button from "src/components/core/Button";

const Container = styled.div`
  width: 100%;
  height: calc(100dvh - 75px);
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WrapperInfo = styled(Box)`
  /* width: 100%; */
  min-width: 450px;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid ${White01};
  background-color: ${White};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const SuccessSection = () => {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderDetail, setOrderDetail] = useState(null);

  useEffect(() => {
    let orderId = searchParams.get("orderId");

    if (!orderId) return;

    const fetchOrderDetail = async () => {
      try {
        const data = await getTokenOrderById(orderId);
        setOrderDetail(data);
      } catch (error) {
        console.error("Error fetching order detail:", error);
      }
    };

    fetchOrderDetail();
  }, [searchParams]);

  return (
    <Container>
      <WrapperInfo>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
            mb: 2,
            backgroundColor: "#DCFCE7",
            borderRadius: "50%",
          }}
        >
          <TaskAltIcon sx={{ fontSize: 40, color: "#00A63E" }} />
        </Box>

        <Typography variant="h5" fontWeight={600}>
          ชำระเงินสำเร็จ
        </Typography>
        <Typography variant="body2" mt={1} mb={6}>
          ขอบคุณสำหรับการสั่งซื้อ ระบบได้รับยอดชำระเงินเรียบร้อยแล้ว
        </Typography>

        {!!orderDetail && (
          <Box
            sx={{
              backgroundColor: "#F9FAFB",
              borderRadius: 2,
              p: 2,
              mb: 4,
              width: "100%",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={1.5}
            >
              <Typography variant="subtitle2" fontWeight={400}>
                เลขออเดอร์
              </Typography>

              <Typography variant="subtitle1">
                {orderDetail?.order_no || "-"}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="subtitle2" fontWeight={400}>
                รหัสทำรายการ
              </Typography>

              <Typography variant="subtitle1">
                {orderDetail?.payment_ref || "-"}
              </Typography>
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={1.5}
            >
              <Typography variant="subtitle2" fontWeight={400}>
                วันที่ทำรายการ
              </Typography>

              <Typography variant="subtitle1">
                {dayjs(orderDetail?.createdAt).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="subtitle2" fontWeight={400}>
                ช่องทางชำระเงิน
              </Typography>

              <Typography variant="subtitle1">
                {orderDetail?.payment_method === "credit_card"
                  ? `Credit Card`
                  : orderDetail?.payment_method === "promptpay"
                    ? `PromptPay`
                    : orderDetail?.payment_method === "truewallet"
                      ? `TrueWallet`
                      : `Other`}
              </Typography>
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="subtitle1">ยอดชำระทั้งสิ้น</Typography>

              <Typography
                variant="h6"
                fontSize={font.size.lg}
                color={"#00A63E"}
              >
                {`${convertPrice(orderDetail?.price)}`}
              </Typography>
            </Stack>
          </Box>
        )}

        <Button
          variant="success"
          fullWidth
          startIcon={<ReceiptIcon />}
          onClick={() => navigate("/seller-token-order")}
        >
          ไปที่หน้าประวัติการสั่งซื้อ
        </Button>

        <Typography variant="body2" mt={3} fontSize={font.size.sm} color={Grey}>
          ระบบจะนำคุณไปยังหน้าประวัติการสั่งซื้ออัตโนมัติใน 10 วินาที
        </Typography>
      </WrapperInfo>
    </Container>
  );
};

export default SuccessSection;
